export const convertToDMS = (decimal: number, type: 'lat' | 'lon') => {
  const degrees = Math.floor(Math.abs(decimal));
  const minutes = Math.floor((Math.abs(decimal) - degrees) * 60);
  const seconds = ((Math.abs(decimal) - degrees) * 60 - minutes) * 60;
  const formattedDegrees = String(degrees).padStart(2, '0');
  const formattedMinutes = minutes.toFixed(0).padStart(2, '0');
  const formattedSeconds = seconds.toFixed(0).padStart(2, '0');
  const direction =
    type === 'lat' ? (decimal >= 0 ? 'N' : 'S') : decimal >= 0 ? 'E' : 'W';
  return `${formattedDegrees}°${formattedMinutes}'${formattedSeconds}"${direction}`;
};

export const convertToDDMM = (decimal: number, type: 'lat' | 'lon') => {
  const degrees = Math.floor(Math.abs(decimal));
  const minutes = (Math.abs(decimal) - degrees) * 60;
  const formattedDegrees = String(degrees).padStart(2, '0');

  // Fix: Handle the case where toFixed might not include decimal part
  const minutesFixed = minutes.toFixed(4);
  const [wholePart, decimalPart = '0000'] = minutesFixed.split('.');

  const formattedMinutes =
    wholePart.padStart(2, '0') + '.' + decimalPart.padStart(4, '0');

  const direction =
    type === 'lat' ? (decimal >= 0 ? 'N' : 'S') : decimal >= 0 ? 'E' : 'W';
  return `${formattedDegrees}°${formattedMinutes}'${direction}`;
};

export const convertToDegrees = (decimal: number, type: 'lat' | 'lon') => {
  const degrees = Math.abs(decimal);
  const formattedDegrees = degrees.toFixed(6).padStart(6, '0');
  const direction =
    type === 'lat' ? (decimal >= 0 ? 'N' : 'S') : decimal >= 0 ? 'E' : 'W';
  return `${formattedDegrees}°${direction}`;
};
